module.exports = __webpack_public_path__ + "img/c0c6b49.png";